import React from 'react';

import Button from './button';
import { hiLoTypes } from '../../../../enums';

const HiLoBet = ({ cardData, onSetMarketData }) => {
  return (
    <div className='content-center-right'>
      <div className='con-center-right-inside'>
        <Button
          type={hiLoTypes.hi}
          name={hiLoTypes.HIGH}
          cardData={cardData}
          betTypeData={cardData?.HIGH}
          onSetMarketData={onSetMarketData}
        />
        <Button
          type={hiLoTypes.lo}
          name={hiLoTypes.LO}
          cardData={cardData}
          betTypeData={cardData?.LO}
          onSetMarketData={onSetMarketData}
        />
      </div>
    </div>
  );
};

export default HiLoBet;
